import { render, staticRenderFns } from "./FootprintPageSingle.vue?vue&type=template&id=9ca5160c&scoped=true&"
import script from "./FootprintPageSingle.vue?vue&type=script&lang=js&"
export * from "./FootprintPageSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca5160c",
  null
  
)

export default component.exports